<template>
  <InputCheckbox v-model="checked" class="mt-4" :label="label" />
</template>

<script setup lang="ts">
const filterStore = useFilterStore();

const props = withDefaults(
  defineProps<{
    label: string;
    checked: boolean;
    title: string;
  }>(),
  {},
);

const checked: Ref<boolean> = ref(props.checked);

watch(checked, (value: boolean, oldValue: boolean) => {
  if (value !== oldValue) {
    filterStore.toggleAlternative(props.title);
  }
});
</script>
